import { ANY_BELGIAN_STATION_SHORT_TARIFF_CODE, ADS_THROUGH_BRUSSELS_SHORT_TARIFF_CODE } from 'constants/booking';

import { types } from 'types/passengers';

export const PUBLIC_NON_FLEX_BP_UPGRADE_PRODUCT = 'PUB_BP_NF_UP';
export const PUBLIC_NON_FLEX_PREMIER_UPGRADE_PRODUCT = 'PUB_PREMIER_UP';
export const CORP_NON_FLEX_BP_UPGRADE_PRODUCT = 'CORP_BP_NF_UP';
export const CORP_NON_FLEX_PREMIER_UPGRADE_PRODUCT = 'CORP_PREMIER_NF_UP';
export const IMPULSE_FROM_STD_TO_SP = 'STD_TO_SP';
export const IMPULSE_FROM_STD_TO_BP = 'STD_TO_BP';
export const IMPULSE_FROM_SP_TO_BP = 'SP_TO_BP';

export const PUBLIC_NON_FLEX_PRODUCTS = [PUBLIC_NON_FLEX_BP_UPGRADE_PRODUCT, PUBLIC_NON_FLEX_PREMIER_UPGRADE_PRODUCT];
export const CORP_NON_FLEX_PRODUCTS = [CORP_NON_FLEX_BP_UPGRADE_PRODUCT, CORP_NON_FLEX_PREMIER_UPGRADE_PRODUCT];

export const mapProductCodeToTariffCode = {
  STD_TO_SP: ['ST_UP_FEE_STD_SP', 'UP_FEE_STD_PLUS'],
  STD_TO_BP: ['ST_UP_FEE_STD_BP', 'UP_FEE_STD_PREM'],
  SP_TO_BP: ['ST_UP_FEE_SP_BP', 'UP_FEE_PLUS_PREM']
};

export const getFaresAvailability = (impulseUpgradeSearch, direction, classCodes = []) => {
  const fares = impulseUpgradeSearch?.impulseUpgradeJourneySearch?.[direction]?.journeys?.[0]?.fares;

  return fares?.find((f) => classCodes.includes(f.classOfService?.code));
};

const { DOG } = types;
const notChargeableTypes = [DOG];

export const getFares = (fareAvailability = {}, typeOfImpulse = 'STD_TO_SP', passengers = []) => {
  const impulseFeePerPerson = fareAvailability?.fees?.find((fee) =>
    mapProductCodeToTariffCode[typeOfImpulse].some((tariffCode) => fee.tariffCode.includes(tariffCode))
  );
  const filterABSFromFareAvailabilities = fareAvailability?.bookingItems?.filter(
    (bi) =>
      bi?.tariffCode?.slice(0, 3) !== ANY_BELGIAN_STATION_SHORT_TARIFF_CODE &&
      bi?.tariffCode?.slice(0, 3) !== ADS_THROUGH_BRUSSELS_SHORT_TARIFF_CODE
  );

  const chargeablePassengerIds = passengers.filter(({ type }) => !notChargeableTypes.includes(type)).map(({ id }) => id);
  const chargeablePassengers = filterABSFromFareAvailabilities.filter(({ passengerId }) => chargeablePassengerIds.includes(passengerId));
  return impulseFeePerPerson?.price * chargeablePassengers?.length;
};
